import { NgModule } from '@angular/core';
import { SatPopoverModule } from '@zerops/zef/popover';
import { PopErrorOutletDirective } from './pop-error-outlet.directive';

@NgModule({
  declarations: [ PopErrorOutletDirective ],
  imports: [ SatPopoverModule ],
  exports: [ PopErrorOutletDirective ]
})
export class ZefPopErrorModule {

}
